import { render, staticRenderFns } from "./attachmentDialog.vue?vue&type=template&id=b50a2846&"
import script from "./attachmentDialog.vue?vue&type=script&lang=js&"
export * from "./attachmentDialog.vue?vue&type=script&lang=js&"
import style0 from "./attachmentDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports